import React from 'react';
import './JobSearchStartDateModal.css'; // Reuse the same styles

const RescanConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Rescan Your Emails?</h2>
        <p className="modal-description">
          Your job search start date has been updated. Would you like to rescan your emails now 
          to find applications based on the new date range?
        </p>
        
        <div className="date-info">
          <p>
            💡 You can always scan later from the Home page by clicking "Authorize Gmail Access" or "Refresh for New Emails".
          </p>
        </div>

        <div className="modal-actions">
          <button 
            onClick={onClose} 
            className="btn-secondary"
          >
            No, I'll Scan Later
          </button>
          <button 
            onClick={onConfirm} 
            className="btn-primary"
          >
            Yes, Rescan Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default RescanConfirmModal;

